<script>
import { authComputed } from '@state/helpers'
import NavBarRoutes from './nav-bar-routes'
// import GoogleSignin from '@components/google-signin'
import SignIn from '@components/login/sign-in'
export default {
  components: { NavBarRoutes, SignIn },
  data() {
    return {
      active: null,
      installBtn: 'none',
      installer: undefined,
    }
  },
  methods: {
    className: function(route) {
      if (this.$route.path == route.name) {
        return 'selected'
      } else {
        return ''
      }
    },
  },
  computed: {
    ...authComputed,
    routes() {
      if (this.isLoggedIn) {
        if (this.isAdmin) {
          return [
            { name: '/', title: 'Home' },
            { name: '/Contact', title: 'Contact' },
            { name: '/AdminPage', title: 'Admin Page' },
            // { name: '/Application', title: 'Application' },
            // { name: '/UserPage', title: 'Inbox' },
            // { name: '/FacilityPage', title: 'Facility' },
            { name: '/Reports', title: 'Reports' },
            // { name: '/Logout', title: 'Logout' },
          ]
        }
        if (this.isApplicant) {
          return [
            { name: '/', title: 'Home' },
            { name: '/Contact', title: 'Contact' },
            // { name: '/AdminPage', title: 'Admin Page' },
            // { name: '/Application', title: 'Application' },
            { name: '/UserPage', title: 'Inbox' },
            // { name: '/FacilityPage', title: 'Facility' },
            // { name: '/Logout', title: 'Logout' },
          ]
        }
        if (this.isFacilitator) {
          return [
            { name: '/', title: 'Home' },
            { name: '/Contact', title: 'Contact' },
            // { name: '/AdminPage', title: 'Admin Page' },
            // { name: '/Application', title: 'Application' },
            { name: '/UserPage', title: 'Inbox' },
            // { name: '/FacilityPage', title: 'Facility' },
            // { name: '/Logout', title: 'Logout' },
          ]
        }
      } else {
        return [
          { name: '/', title: 'Home' },
          { name: '/Contact', title: 'Contact' },
          // { name: '/Login', title: 'Login' },
        ]
      }
    },
  },
  created() {
    let installPrompt

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      installPrompt = e
      this.installBtn = 'inline-block'
    })

    this.installer = () => {
      this.installBtn = 'none'
      installPrompt.prompt()
      installPrompt.userChoice.then((result) => {
        if (result.outcome === 'accepted') {
          console.log('Install accepted!')
        } else {
          console.log('Install denied!')
        }
      })
    }
  },
}
</script>

<template>
  <v-toolbar flat class="primary customToolbar">
    <img src="../assets/HealthLogoSm.png" class="logoBanner" />
    <v-toolbar-title class="toolbarTitle"
      >Wyoming Department of Health</v-toolbar-title
    >
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down navCustom">
      <div v-for="item in routes" :key="item.title">
        <v-btn
          flat
          :class="className(item)"
          :to="`${item.name}`"
          class="btnCustom"
          >{{ item.title }}</v-btn
        >
      </div>
      <SignIn></SignIn>
    </v-toolbar-items>
    <v-menu class="hidden-md-and-up" disable-resize-watcher>
      <v-toolbar-side-icon slot="activator" dark></v-toolbar-side-icon>
      <v-list>
        <v-list-tile
          v-for="item in routes"
          :key="item.title"
          :to="`${item.name}`"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<style>
.customToolbar {
  margin-bottom: 25px;
}

.logoBanner {
  max-width: 6%;
  background-color: white;
  padding: 4px;
}
.toolbarTitle {
  /* padding-left: 15px; */
  padding-top: 4px;
}

.navCustom {
  margin-top: -3px;
}

.v-btn.btnCustom:hover {
  background-color: rgba(230, 216, 197, 0.5);
}

.v-btn.btnCustom {
  padding: 22px 5px;
  color: #e6d8c5;
  font-weight: bold;
  border-radius: none;
}

.selected {
  background-color: #e6d8c5;
  color: #77340d !important;
}
</style>
